import script from "./addon.vue?vue&type=script&lang=js"
export * from "./addon.vue?vue&type=script&lang=js"

import "./addon.vue?vue&type=style&index=0&id=47e7df28&lang=scss"

const __exports__ = script;

export default __exports__